import { render, staticRenderFns } from "./helloTong.vue?vue&type=template&id=87c9f494&scoped=true"
import script from "./helloTong.vue?vue&type=script&lang=ts"
export * from "./helloTong.vue?vue&type=script&lang=ts"
import style0 from "./helloTong.vue?vue&type=style&index=0&id=87c9f494&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c9f494",
  null
  
)

export default component.exports